import React from "react";
import { Grid, Typography, CardHeader, CardContent } from "@mui/material";
import { BarChart } from "@mui/x-charts/BarChart";
import { ChartCard } from "../Style/health-chart.style";

export default function HealthFacilityChart({ selectedDistrict, allDistrictsChartData }) {
    // Prepare and sort data by total count (low to high)
    const chartData = selectedDistrict === 'ALL'
        ? allDistrictsChartData.map(d => ({
            district: d.DISTRICT,
            healthFacilities: Number(d.count_hfn || 0),
            villages: Number(d.count_villages || 0)
        }))
        : [{
            district: selectedDistrict,
            healthFacilities: Number(allDistrictsChartData.find(d => d.DISTRICT === selectedDistrict)?.count_hfn || 0),
            villages: Number(allDistrictsChartData.find(d => d.DISTRICT === selectedDistrict)?.count_villages || 0)
        }];

    // Sort by total count (low to high)
    const sortedChartData = chartData.sort((a, b) =>
        (a.healthFacilities + a.villages) - (b.healthFacilities + b.villages)
    );

    return (
        <Grid item xs={12} md={2} sx={{ width: "450px" }}>
            <ChartCard>
                <CardHeader
                    title={
                        <Typography
                            variant="subtitle1"
                            sx={{ fontWeight: "bold", fontSize: "14px", textAlign: 'center', textDecorationLine: 'underline' }}
                        >
                            Health Facility/Villages Where CMHAs Screening is Started
                        </Typography>
                    }
                    sx={{ pb: 0 }}
                />
                <CardContent>
                    <BarChart
                        yAxis={[{
                            width: 100,
                            scaleType: 'band',
                            data: sortedChartData.map(d => d.district),
                            tickLabelStyle: { fontSize: 12 },
                            barGapRatio: 0.1
                        }]}
                        series={[
                            {
                                data: sortedChartData.map(d => d.healthFacilities),
                                label: 'Health Facility Where CMHAs Screening is Started',
                                color: '#2196f3'
                            },
                            {
                                data: sortedChartData.map(d => d.villages),
                                label: 'Villages Where CMHAs Screening is Started',
                                color: '#4caf50'
                            }
                        ]}
                        layout="horizontal"
                        height={425}
                        slotProps={{
                            legend: {
                                direction: "horizontal",
                                position: { horizontal: "center", vertical: "bottom" },
                            },
                        }}
                    />
                </CardContent>
            </ChartCard>
        </Grid>
    );
}
